import {
  useCreateShopItemMutation,
  useLazyGetShopCategoriesQuery,
  useLazyGetUserShopsByBusinessTypeQuery,
} from "../features/shop/shopApiSlice";

export const useNewItemsPostAdd = () => {
  const [createShopItem, { isLoading: isCreatingItem }] = useCreateShopItemMutation();
  const [triggerGetCategories] = useLazyGetShopCategoriesQuery();
  const [triggerUserShops] = useLazyGetUserShopsByBusinessTypeQuery();

  return {
    createShopItem,
    isCreatingItem,
    triggerGetCategories,
    triggerUserShops,
  };
};

export default useNewItemsPostAdd;
